import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';

const SearchBtn = () => {
  return (
    <>
      <Box className="flex aic jcc" type="submit">
        <span className="img-box">
          <img src="/img/ico_search_fff.svg" alt="" />
        </span>
      </Box>
    </>
  );
};

export default SearchBtn;

const Box = styled.button`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 4px;
  background-color: #292e42;
  .img-box {
    width: 16px;
  }
`;
